export class ModalConfirmacao {
  constructor(
    public titulo: string = '',
    public descricao: string = '',
    public html?: string,
    public btnMsgOk?: string,
    public btnMsgCancelar?: string,
    public tipo?: number,
    public aberto?: boolean,
    public index?:number
  ) {

  }
}
